import React, { Component } from 'react'
import { Box, Card, CardContent, CardMedia, Typography, Grid } from "@mui/material";
import IbssSvgIcon from '../../Icons/SvgIcon/IbssSvgIcon';
import CaretRightIcon from '../../Icons/CaretRightIcon';


export default class IbssHomeCard extends Component<IProps>
{

    public render(): JSX.Element 
    {
        const { src, imageAlt, title, description, route } = this.props;
        return (
            <Card sx={{ display: 'flex', cursor: 'pointer'}} onClick={() => this.props.redirect(route)}>
                <CardMedia
                    component="img"
                    sx={{ width: 160, minWidth: 160, height: 130, objectFit: 'cover' }}
                    image={src}
                    alt={imageAlt}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center' }}>
                    <CardContent className="card-botom-spacing-0">
                        <Grid container spacing={2} sx={{ pb: 0 }}>
                            <Grid item sm={11}>
                                <Typography variant="h6" component="div" mb={2}>
                                    {title}
                                </Typography>
                                <Typography variant="body2">
                                    {description}
                                </Typography>
                            </Grid>
                            <Grid item sm={1} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                {
                                    <IbssSvgIcon
                                        sx={{ fontSize: '0.75rem', cursor: 'pointer', padding: '8px', '&:hover': { opacity: 0.8 } }}>
                                        <CaretRightIcon />
                                    </IbssSvgIcon>
                                }
                            </Grid>
                        </Grid>
                    </CardContent>
                </Box>
            </Card >
        )
    }
}

interface IProps
{
    id?: number;
    title: string;
    description: string;
    src: string;
    imageAlt: string;
    route: string;
    redirect: (route: string) => void;
}